import React, { useState, useEffect } from "react";
import { random } from "lodash"

import {useTheme} from "@mui/material/styles"


    const RYGGColors = ['#c0c0c0', '#4eb748', '#E7C61E', '#E6323A']
    const RaimbowColors = ['#e74645', '#fb7756', '#facd60', '#fdfa66', '#1ac0c6', '#454d66', '#309975', '#58b368', '#dad873', '#efeeb4']
    
    export const GetScoreColor = (score) => {
        const vg = parseInt((score >=0 && score <= 39) ? 3 : score <= 69 ? 2 : score <= 100 ? 1 : 0)
        return RYGGColors[vg]
    }

    export const GetValueGradeColor = (score) => {
        return RYGGColors[score]
    }

    export const GetRainbowColor=(index)=>{
        return RaimbowColors[index]
    }

    
    export const GetRainbowCustom=(csv)=>{
        let csvArr = csv.split(',')
        return RaimbowColors.filter((x,i)=>{ return csvArr.indexOf(i)>=0 })
    }
    
    export const GetColor = (fnc, val) => {
         const theme = useTheme()
        if(fnc ==='RYGG SCORE'){
           return GetScoreColor(val) 
        } else if (fnc==='RAINBOW'){
            return GetRainbowColor(val) 
         } else if (fnc==='PRIMARY'){
            return theme.palette.primary.main
         }else if (fnc==='SECONDARY'){
            return theme.palette.secondary.main
         }else if (fnc==='RYGG VALUE GRADE'){
            return GetValueGradeColor(val) 
         }else if (fnc==='RAINBOW CUSTOM'){
            return RYGGColors
         }else if (fnc==='RYGG ARRAY'){
            return RYGGColors
         } else if (fnc==='RAINBOW ARRAY'){
            return RaimbowColors
         } else {
            return GetRainbowColor(val?val : random(0,RaimbowColors.length-1))
        }
    }